import { DropzoneOptions, FileRejection, useDropzone } from 'react-dropzone';
import { useTranslation } from '@sib/i18n';
import { Button, cn } from '@sib/ui';
import { DOCUMENTS_DROPZONE_CONFIG } from '@sib/utils';

interface DropzoneContentProps {
  dropzoneConfig?: Partial<DropzoneOptions>;
  disabled: boolean | undefined;
  onDrop: (acceptedFiles: File[], rejectedFiles: FileRejection[]) => void;
}

export const DropzoneContent = ({
  dropzoneConfig,
  onDrop,
  disabled,
}: DropzoneContentProps) => {
  const { t } = useTranslation();
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    ...(dropzoneConfig || DOCUMENTS_DROPZONE_CONFIG),
    onDrop,
    disabled,
  });

  return (
    <div
      {...getRootProps()}
      className={cn(
        'border-border relative flex w-full cursor-pointer items-center justify-center rounded-lg border-dashed p-2.5 text-center transition-colors sm:p-4 md:border-2',
        isDragActive ? 'border-primary' : 'border-muted-foreground/50',
        disabled && 'cursor-not-allowed'
      )}
    >
      <input {...getInputProps()} />
      <p className="text-muted-foreground hidden text-xs leading-4 font-bold md:block md:max-w-5 lg:max-w-full">
        {t('uploadDocuments.dragAndDrop')}
      </p>

      <Button
        variant="outline"
        type="button"
        className="absolute right-2"
        disabled={disabled}
      >
        {t('uploadDocuments.browse')}
      </Button>
    </div>
  );
};
